import { useState,useEffect } from 'react';
import { useNavigate } from 'react-router-dom';



const Logout = () => {
  const navigate = useNavigate();
 const [user, setUser] = useState(null);
  useEffect(() => {
    const logout = async () => {
      try {
         
	localStorage.removeItem("token");
    localStorage.removeItem("user");
    setUser(null);
    navigate("/login");// remove token if using JWT
        navigate('/login'); // redirect to login
      } catch (error) {
        console.error('Logout failed:', error);
        navigate('/login');
      }
    };

    logout();
	   window.location.reload();
  }, [navigate]);

  return <p>Logging out...</p>;
};

export default Logout;
